// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'box-3-solid';

export const Component = () => (
  <path d='M1 15.897V9h6.897v6.897H1Zm7.855 0V9h6.897v6.897H8.855Zm7.854 0V9h6.896v6.897H16.71Z' />
);

export const viewBox = '0 0 25 25';
